import _styles from './index.module.css'

export default function Skeleton({ variant = 'block' }: { variant?: string }) {
  return <div className={`${_styles.skeleton} ${_styles['skeleton-' + variant]}`} />
}
